import ISelectable from "../interfaces/ISelectable";

export default class Transformer {
	public static toISelectable(
		val: string,
		extraDisplayText?: string
	): ISelectable {
		return {
			key: val.replace(new RegExp(" ", "g"), "-").toLowerCase(),
			displayText: extraDisplayText ? val + " " + extraDisplayText : val,
			value: val,
		};
	}

	public static arrayToISelectable(
		theArray: string[],
		extraDisplayText?: string
	): ISelectable[] {
		const newArray: ISelectable[] = [];

		for (let i = 0; i < theArray.length; i++) {
			const item = Transformer.toISelectable(
				theArray[i],
				extraDisplayText
			);
			newArray.push(item);
		}

		return newArray;
	}
}
